import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e80942a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-1" }
const _hoisted_2 = { class: "action-menu-row flex p-4" }

import { Component, ref, nextTick, onUnmounted } from "vue";
import { DotsHorizontalIcon } from "@heroicons/vue/solid";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null,
    truncateLabels: null,
    actions: null
  },
  setup(__props: any) {

const props = __props as {
  item?: any;
  truncateLabels?: boolean;
  actions: {
    text: string;
    icon: Component;
    iconColor: string;
    disabled?: boolean;
    title?: string;
    action: (item: any) => void;
  }[];
}

/* global defineProps */


const trigger = ref<{ $el: HTMLElement } | null>(null);
const menuItems = ref<{ $el: HTMLElement } | null>(null);
const menuPosition = ref({
  left: "16px",
  top: "16px",
  width: "224px",
  maxHeight: "calc(100vh - 32px)",
  overflowY: "auto" as const,
});
let positionFrame = 0;
let tracking = false;

function updatePosition() {
  const anchor = trigger.value?.$el;
  if (!anchor?.getBoundingClientRect) return;
  const bounds = anchor.getBoundingClientRect();
  const longestLabel = props.actions.reduce((length, action) => Math.max(length, action.text.length), 0);
  const preferredWidth = props.truncateLabels ? Math.min(480, Math.max(224, 64 + longestLabel * 7.5)) : 224;
  const width = Math.min(preferredWidth, Math.max(1, window.innerWidth - 32));
  const height = Math.min(
    menuItems.value?.$el?.offsetHeight || 240,
    window.innerHeight - 32
  );
  const below = bounds.bottom + 6;
  menuPosition.value = {
    left: `${Math.max(
      16,
      Math.min(bounds.right - width, window.innerWidth - width - 16)
    )}px`,
    top: `${Math.max(
      16,
      Math.min(
        below + height <= window.innerHeight - 16
          ? below
          : bounds.top - height - 6,
        window.innerHeight - height - 16
      )
    )}px`,
    maxHeight: "calc(100vh - 32px)",
    width: `${width}px`,
    overflowY: "auto",
  };
}

function schedulePosition() {
  if (!positionFrame)
    positionFrame = window.requestAnimationFrame(() => {
      positionFrame = 0;
      updatePosition();
    });
}

async function startTracking() {
  tracking = true;
  await nextTick();
  if (!tracking) return;
  updatePosition();
  window.addEventListener("scroll", schedulePosition, true);
  window.addEventListener("resize", schedulePosition);
}

function stopTracking() {
  tracking = false;
  window.removeEventListener("scroll", schedulePosition, true);
  window.removeEventListener("resize", schedulePosition);
  if (positionFrame) window.cancelAnimationFrame(positionFrame);
  positionFrame = 0;
}

onUnmounted(stopTracking);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative inline-block text-left"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", null, [
        _createVNode(_unref(MenuButton), {
          ref: (_value, _refs) => {
            _refs['trigger'] = _value
            trigger.value = _value
          },
          onClick: updatePosition,
          onKeydown: updatePosition,
          class: "action-menu-trigger inline-flex justify-center w-full rounded-md shadow-sm px-4 py-0 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500",
          "aria-label": _ctx.$t('common.actions')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DotsHorizontalIcon), { class: "w-6 h-6 text-gray-600 cursor-pointer" })
          ]),
          _: 1
        }, 8, ["aria-label"])
      ]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            open
              ? (_openBlock(), _createBlock(_unref(MenuItems), {
                  key: 0,
                  ref: (_value, _refs) => {
                    _refs['menuItems'] = _value
                    menuItems.value = _value
                  },
                  style: _normalizeStyle(menuPosition.value),
                  class: "action-menu-items origin-top-right fixed w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
                  "onVue:mounted": startTracking,
                  "onVue:unmounted": stopTracking
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.actions, (action, index) => {
                        return (_openBlock(), _createBlock(_unref(MenuItem), {
                          class: _normalizeClass(["cursor-pointer hover:bg-gray-100", { 'opacity-50 cursor-not-allowed': action.disabled }]),
                          key: index,
                          disabled: action.disabled,
                          title: action.title || action.text,
                          onClick: _withModifiers(($event: any) => (!action.disabled && action.action(__props.item?.id)), ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon), {
                                class: _normalizeClass(["w-5 h-5 flex-shrink-0", [action.iconColor]])
                              }, null, 8, ["class"])),
                              _createElementVNode("span", {
                                class: _normalizeClass(["pl-3", { 'action-menu-label--truncate': __props.truncateLabels }])
                              }, _toDisplayString(action.text), 3)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "title", "class", "onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]))
    ]),
    _: 1
  }))
}
}

})